"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_White__Transparant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 284 284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#333333"
    }
  }, props), /*#__PURE__*/React.createElement("title", null, "Logos / Vodafone-Logo / White-Transparant"), /*#__PURE__*/React.createElement("g", {
    id: "Logos-/-Vodafone-Logo-/-White-Transparant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.001,0 C163.757082,0 184.370467,4.89271331 202.800817,13.6378678 C200.361406,12.8237255 196.398327,12.5090453 192.608,12.5216173 C163.056,12.62 130.471,25.259 106.686,44.954 C82.3013,65.147 63.2243,99.183 63.3419537,134.543 C63.5199,188.012 104.11,221.3109 143.126,221.181975 C191.293,221.0213 219.792,181.47 219.673371,145.372 C219.552,109.272 199.924,83.183 156.686,72.652 C156.597,72.203 156.515,71.24 156.512,70.338 C156.422,43.056 176.987,19.009 202.826,13.65 C250.815886,36.4305492 284.001,85.3396065 284.001,142 C284.001,220.425 220.425,284 142.001,284 C63.576,284 1.93267624e-12,220.425 1.93267624e-12,142 C1.93267624e-12,63.575 63.576,0 142.001,0 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })));
}

var _default = ic_White__Transparant;
exports.default = _default;